import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import SupplementaryInvoiceContMain from "presentation/view/container/SupplementaryInvoice/SupplementaryInvoiceContMain";

CommonEntrypoint(<SupplementaryInvoiceContMain/>)